<div class="callback-container">
  <div class="callback-content">
    <img src="assets/rettxlogo.png" alt="rettX" class="callback-logo" width="120" height="45" />
    
    <mat-spinner [diameter]="48"></mat-spinner>
    
    <p class="callback-text">{{ 'AUTH.CALLBACK.AUTHENTICATING' | translate }}</p>
  </div>
</div>